// Additional Libraries
import { sliders } from '../modules/sliders';
import { modals } from '../modules/person-modals';

export default {
	init() {
		// JavaScript to be fired on all pages
		setup_scrolling();
		//back_to_top();
		//rellax();
		setup_site_loader();
		setup_active_menu_classes();
		sliders();
		modals();
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};

/**
 * Sets the active class on the menu
 */
function setup_active_menu_classes()
{
	//Update the menu based on urls
	let url = window.location.href;
	let hash = window.location.hash;
	url = url.replace(hash, '');

	let menu_selectors = $('#menu-main-menu a');
	menu_selectors.removeClass('current-menu-item');

	$('li.menu-item.current-menu-item').removeClass('current-menu-item');
	let active_items = $('#menu-main-menu').find('a[href="' + url + '"]');
	active_items.each(function(){
		$(this).parent().addClass('current-menu-item');
	});
}


function setup_scrolling()
{
	$(window).on('scroll', function() {
		//Add the 'scrolled' class
		let scroll = $(this).scrollTop();
		let body = $('body');
		if(scroll > 0)
		{
			body.addClass('scrolled');
		}
		else
		{
			body.removeClass('scrolled');
		}

		//Add a class when scrolling past 100vh
		let landing = $('.REFERENCE_DIV_HERE');
		if(scroll >= landing.height())
		{
			body.addClass('fold');
		}
		else
		{
			body.removeClass('fold');
		}

	});
}

/*
function back_to_top()
{
	$('.back-to-top').click(function (e){
		e.preventDefault();
		$('html,body').animate({
			scrollTop: 0,
		}, 'slow');
	});
}
*/

/*
function rellax()
{
	var rellax = new Rellax('.rellax', {
		center: false,
	});
}
*/


function setup_site_loader()
{
	setTimeout(function(){
		let loader = $('.site-loader');
		loader.removeClass('active');
	}, 1500);
}




// WEBPACK FOOTER //
// ./scripts/routes/common.js